import { createContext, useContext } from 'react';
import { useSelector } from 'react-redux';
import { getIsDuperbrowseActive } from './redux/selectors';
export const DuperbrowseViewContext = createContext(undefined);
DuperbrowseViewContext.displayName = 'DuperbrowseViewContext';
export function useDuperbrowseViewType() {
    const viewType = useContext(DuperbrowseViewContext);
    const isActive = useSelector(getIsDuperbrowseActive);
    return {
        viewType,
        isInDuperbrowse: isActive
    };
}
